//#region components/tab/tabs_constants.js
var e = ["default", "sm"], t = { sm: "d-tablist--sm" }, n = { inverted: "d-tablist--inverted" }, r = { borderless: "d-tablist--no-border" }, i = { selected: "d-tab--selected" };
//#endregion
export { i as TAB_IMPORTANCE_MODIFIERS, r as TAB_LIST_IMPORTANCE_MODIFIERS, n as TAB_LIST_KIND_MODIFIERS, e as TAB_LIST_SIZES, t as TAB_LIST_SIZE_MODIFIERS };

//# sourceMappingURL=tabs-constants.js.map